export default class ResetHandler {
    constructor(User) {
        this.userRepo = User;        
    }
    
    doReset(email) {
        return this.userRepo.reset(email);
    }
};

ResetHandler.$inject = ['User'];
